import { toLandingLeadForm } from '@/articles/v4/landing_lead_form';

pageLoad('pages_dostavka', () => {
  $('article.slide-3 .submit').on('click', toLandingLeadForm);
});
